import { useEffect } from 'react';

export const useHiddenV1Container = () => {
  useEffect(() => {
    const v1Element = document.getElementById('v1-container');

    if (v1Element) {
      v1Element.style.setProperty('display', 'none');

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style' &&
            v1Element.style.display !== 'none'
          ) {
            v1Element.style.setProperty('display', 'none');
          }
        });
      });

      observer.observe(v1Element, { attributes: true, attributeFilter: ['style'] });

      return () => {
        observer.disconnect();
      };
    }
  }, []);
};
